import React from 'react';
import { PortalHeaderLayout } from '../../ui-widgets/portal-header-layout/portal-header-layout';

import './portal-dashboard-layout.scss';

interface PortalDashboardLayoutProps {
    headerChildren?: React.ReactNode;
    buttonElement?: React.ReactNode;
    headerIsSingleRow?: boolean;
    isDetail?: boolean;
    title: string;
    titleIcon?: string;
    onBackArrowClick?: () => void;
}

export const PortalDashboardLayout: React.FC<PortalDashboardLayoutProps> = ({
    headerChildren,
    buttonElement,
    headerIsSingleRow = false,
    isDetail = false,
    title,
    titleIcon,
    onBackArrowClick,
    children,
}): React.ReactElement => {
    return (
        <div className="portal-dashboard-layout">
            <div className="portal-dashboard-layout__header">
                <PortalHeaderLayout
                    isSingleRow={headerIsSingleRow}
                    isDetail={isDetail}
                    title={title}
                    titleIcon={titleIcon}
                    onBackArrowClick={onBackArrowClick}
                    buttonElement={buttonElement}
                >
                    {headerChildren}
                </PortalHeaderLayout>
            </div>
            <div className="portal-dashboard-layout__content">{children}</div>
        </div>
    );
};
